import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { StepNavigationStyled } from '@components/v2/StepNavigation/StepNavigationStyled';

export const StepNavigationStyledAC = styled(StepNavigationStyled)`
    .closed,
    .opened {
        background: ${({ theme }) => theme.colors.grey6};
        .chevron-down {
            svg path {
                fill: ${({ theme }) => theme.colors.red};
            }
        }
        .contactUsContainer {
            font-size: 16px;
            font-weight: bold;

            .contactUsNumber {
                color: #3b3938;
            }
        }

        .wrapper {
            .blurryHolder {
                @media (min-width: ${breakpoints.lg}px) {
                    .icon-wrapper {
                        position: absolute;
                        z-index: 999;

                        &:after {
                            width: 19px;
                            height: 19px;
                            display: flex;
                            content: ${({ theme }) => `url('data:image/svg+xml;utf8,
                                <svg aria-hidden="true" width="19px" height="19px" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.15203 18.3188L1.72319 18.8789L10.5765 9.85176L1.48033 0.914551L0.919647 1.4852L9.44565 9.86224L1.15203 18.3188Z" fill="${encodeURIComponent(
                                      theme.colors.blue2
                                  )}" stroke="${encodeURIComponent(theme.colors.blue2)}" stroke-width="1.2"></path>
                                </svg>')`};
                        }

                        svg {
                            display: none;
                        }
                    }
                }
            }

            .container .nav-item {
                position: relative;
                &:hover {
                    .title {
                        color: ${({ theme }) => theme.colors.blue2};
                    }
                    border-color: transparent;

                    .selectedBorder {
                        @media (min-width: ${breakpoints.md}px) {
                            display: block;
                        }
                    }
                }

                .selectedBorder {
                    display: none;
                    width: 100%;
                    height: 5px;
                    position: absolute;
                    background: red;
                    bottom: -6px;
                    background: ${({ theme }) => theme.colors.blue2};
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                }
                .icon {
                    background-color: ${({ theme }) => theme.colors.grey8};
                    border-color: ${({ theme }) => theme.colors.grey8};
                    &.selected {
                        background: ${({ theme }) => theme.colors.blue2};
                        border-color: ${({ theme }) => theme.colors.blue2};
                        svg g {
                            fill: ${({ theme }) => theme.colors.white};
                        }
                    }
                }

                .title {
                    font-size: ${({ theme }) => theme.fontSizes.h4};
                    color: ${({ theme }) => theme.colors.grey27};
                }
            }
        }
    }
`;
